import QuadrantsForCameraAngle from './QuadrantsForCameraAngle';
import ParameterErrors from '../../../errors/ParameterErrors';
const { throwNotProvided } = ParameterErrors;
const XYZ_FROM_JSON_KEY_JSON_KEY='f',
	SCENE_SIZE_JSON_KEY='s',
	YAW_PITCH_QUADRANTS_JSON_KEY='q';
const TWO_PI=Math.PI*2;
export default class QuadrantsV2{
	constructor({xYZFrom, sceneSize,  yaw_Pitch_Quadrants}){
		this._xYZFrom = xYZFrom;
		this._sceneSize = sceneSize;
		this._yaw_Pitch_Quadrants = yaw_Pitch_Quadrants; 
		this._yawLength = this._yaw_Pitch_Quadrants.length;
		this._pitchLength = this._yaw_Pitch_Quadrants[0].length;
	}
	get xYZFrom(){
		return this._xYZFrom;
	}
	get sceneSize(){
		return this._sceneSize;
	}
	getObjectIds({yawRadians, pitchRadians, x, y, z}){
		while(yawRadians<0)yawRadians+=TWO_PI;
		while(pitchRadians<0)pitchRadians+=TWO_PI;
		const yawIndex = parseInt(yawRadians*this._yawLength/TWO_PI);
		console.log('yaw index is '+yawIndex+' out of '+this._yawLength);
		const pitchIndex = parseInt(pitchRadians*this._pitchLength/TWO_PI);
		console.log('pitchIndex index is '+pitchIndex+' out of '+this._pitchLength);
		const quadrantsForCameraAngle = this._yaw_Pitch_Quadrants[yawIndex][pitchIndex];
		if(quadrantsForCameraAngle ===null||quadrantsForCameraAngle===undefined)return null;
		const proportionX = x/this._sceneSize[0], proportionY = y/this._sceneSize[1], proportionZ = z/this._sceneSize[2];
		console.log('proportionX is '+proportionX+' proportionY '+proportionY+' proportionZ '+proportionZ);
		return quadrantsForCameraAngle.getObjectIds({proportionX, proportionY, proportionZ});
	}
	static fromJSON(jObject){
		const xYZFrom = jObject[XYZ_FROM_JSON_KEY_JSON_KEY];
		const sceneSize = jObject[SCENE_SIZE_JSON_KEY];
		const yaw_Pitch_Quadrants = 
			jObject[YAW_PITCH_QUADRANTS_JSON_KEY]
			.map(pitch_Quadrants=>
				pitch_Quadrants
				.map(jObjectQuadrants=>
						QuadrantsForCameraAngle.fromJSON(jObjectQuadrants)
				)
			);
		return new QuadrantsV2({xYZFrom, sceneSize,
			yaw_Pitch_Quadrants});
	}
}